module.exports = __webpack_public_path__ + "img/yijieshu.71dab5e6.svg";